import defaults from '../../translations/en.json';
import { ADM, DIS } from '../Context/constants';

export const Daystoadmitdeadline = 'daystoadmitdeadline';
export const Daystodischargedeadline = 'daystodischargedeadline';
export const Demographicsstatus = 'demographicsstatus';
export const Bshowadminactionbuttons = 'bshowadminactionbuttons';

export const Approval = 'approval';
export const Due = 'Due';
export const Download = 'download';
export const Downloaded = 'downloaded';
export const Cmsapproved = 'cmsapproved';
export const Submit_Due = 'submit_due';

export const Hisadmineventdto = 'hisadmineventdto';
export const Hiscachedpatientitemdto = 'hiscachedpatientitemdto';

export const redColor = '#FD5C63';
export const greenColor = '#ACE1AF';

export const Sent = 'Sent';

export const APPROVE = 'APPROVE';
export const DUE = 'DUE';
export const CMS_ACCEPTANCE = 'CMS ACCEPTANCE';

export const vertical = 'vertical';
export const horizontal = 'horizontal';

export const typeMap = new Map();
typeMap.set(ADM, [defaults.Admit, 'a', 'admitdatedisplay']);
typeMap.set(DIS, [defaults.Discharge, 'd', 'dischargedatedisplay']);

export const hospiceDataAdmit = [
  {
    name: defaults.daystodeadline,
    key: Daystoadmitdeadline,
    title: Daystoadmitdeadline,
    type: ADM,
  },
  {
    name: defaults.approval,
    key: Hisadmineventdto,
    title: Approval,
    type: ADM,
  },
  {
    name: defaults.downloadSend,
    key: Hisadmineventdto,
    title: Download,
    type: ADM,
  },
  {
    name: defaults.cmsaccepted,
    key: Hisadmineventdto,
    title: Cmsapproved,
    type: ADM,
  },
];

export const hospiceDataDischarge = [
  {
    name: defaults.daystodischargedeadline,
    key: Daystodischargedeadline,
    title: Daystodischargedeadline,
    type: DIS,
  },
  {
    name: defaults.approval,
    key: Hisadmineventdto,
    title: Approval,
    type: DIS,
  },
  {
    name: defaults.downloadSend,
    key: Hisadmineventdto,
    title: Download,
    type: DIS,
  },
  {
    name: defaults.cmsaccepted,
    key: Hisadmineventdto,
    title: Cmsapproved,
    type: DIS,
  },
];

export const valueByType = (data: mumms.HISadmineventdto[]) =>
  data.length
    ? data.reduce((seed: any, item: any) => {
        const { type } = item;
        if (seed[type]) {
          seed[type].push(item);
        } else {
          seed[type] = [item];
        }
        return seed;
      }, {})
    : [];

export const getStatusData = (
  data: any,
  type: mumms.patientStatus,
  daysKey: 'daystoadmitdeadline' | 'daystodischargedeadline',
) =>
  Object.keys(data).reduce(
    (seed, key) => {
      if (key === daysKey || key === Hiscachedpatientitemdto) {
        seed[key] = {
          value: data[key as mumms.HISkey],
        };
      }
      if (key === Hisadmineventdto) {
        seed[key] = {
          value: valueByType(data[key as mumms.HISkey]),
        };
      }
      return seed;
    },
    { type } as any,
  );

export const getRowClass = (type: mumms.patientStatus) =>
  type === ADM ? 'blue-row no-border' : 'red-row no-border';
